import { autoplayOnScroll } from 'utilities/video';

function initNewTrendingPage () {

	const newTrendingVideo = document.querySelector('.newTrending__video');

	let autoplayObserver;
	if (newTrendingVideo) {

		autoplayObserver = autoplayOnScroll();
		autoplayObserver.observe(newTrendingVideo);

	}
	
	return [ function () {

		if (autoplayObserver) {

			autoplayObserver.disconnect();

		}

	} ];

}

export default initNewTrendingPage;
